var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-container',{scopedSlots:_vm._u([{key:"sidebar",fn:function(){return [_c('category-nav')]},proxy:true},{key:"content",fn:function(){return [_c('carousel-main')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }